module.exports = "/assets/site/images/bszk.png?832d11d3d89dd74a65791255d244d88d";